import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DropdownList } from 'react-widgets';
import { Message } from 'primereact/message';
import { SEARCHING_TIME_DELAY } from '../../shared/Constants';

export class FormAsyncSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selecting: null,
      selected: null,
      selectingRespondent: null,
    };
  }

  search = (value) => {
    const { dataSearch } = this.props;
    const { selecting } = this.state;
    if (selecting) {
      clearTimeout(selecting);
    }

    const searchTimer = setTimeout(() => {
      dataSearch(value);
    }, SEARCHING_TIME_DELAY);

    this.setState({
      selecting: searchTimer,
    });
  }

  change = async (selected) => {
    const { setFieldValue, name } = this.props;
    setFieldValue(name, selected);
    this.setState({
      selected,
    });
  }

  select = async (res) => {
    this.setState({ selectingRespondent: res });
  }

  toggle = async (forOpen) => {
    setTimeout(() => {
      const { selectingRespondent } = this.state;
      if (!forOpen) {
        if (!selectingRespondent) {
          this.setState({ selected: null });
        }
      } else {
        this.setState({ selectingRespondent: null });
      }
    });
  }

  render() {
    const {
      data, processing, selectedList,
      value, ...rest
    } = this.props;
    let { selected } = this.state;
    const fitData = processing ? [] : data;
    const selectedItems = selectedList || [];
    const disabledList = [];
    selectedItems.forEach((item) => {
      disabledList.push(item);
    });

    if (!value) {
      selected = null;
    } else if (selected) {
      const already = disabledList.find(item => item.id === selected.id);
      if (!already) {
        disabledList.push(selected);
      }
    } else {
      selected = value;
    }

    return (
      <div>
        <DropdownList
          {...rest}
          readOnly={processing}
          busy={processing}
          data={fitData}
          onSearch={this.search}
          filter={item => (item)}
          onChange={this.change}
          onBlur={() => {
          }}
          value={selected}
          onSelect={this.select}
          onToggle={this.toggle}
          disabled={disabledList}
          messages={{
            emptyList: processing ? '...' : null,
          }}
        />
      </div>
    );
  }
}

FormAsyncSelector.propTypes = {
  dataSearch: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  selectedList: PropTypes.arrayOf(PropTypes.any),
  processing: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.objectOf(PropTypes.any),
  ]),
};

FormAsyncSelector.defaultProps = {
  selectedList: [],
  value: null,
};

export const renderAsyncSelector = (props) => {
  const {
    field,
    form: { errors },
    onSearch,
    ...rest
  } = props;
  return (
    <div>
      <FormAsyncSelector
        {...field}
        {...props}
        dataSearch={onSearch}
        {...rest}
      />
      {errors[field.name]
        && (
          <div>
            <Message severity="error" text={errors[field.name]} />
          </div>
        )
      }
    </div>
  );
};

renderAsyncSelector.propTypes = {
  field: PropTypes.objectOf(PropTypes.any).isRequired,
  form: PropTypes.objectOf(PropTypes.any).isRequired,
  onSearch: PropTypes.func.isRequired,
};
